export default class CookieService {
    public static getCookie(name: string): string | undefined {
        const parts = document.cookie.split(name + '=');
        if (parts.length === 2) 
            return parts.pop()?.split(';').shift();
    }

    public static expireCookie(name: string) {
        document.cookie = encodeURIComponent(name) + '=; expires=' + new Date(0).toUTCString();
    }
}
